import { render, staticRenderFns } from "./NewsletterPopup.vue?vue&type=template&id=b6059fb8&scoped=true"
import script from "./NewsletterPopup.vue?vue&type=script&lang=js"
export * from "./NewsletterPopup.vue?vue&type=script&lang=js"
import style0 from "./NewsletterPopup.vue?vue&type=style&index=0&id=b6059fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6059fb8",
  null
  
)

export default component.exports